import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useFormState } from 'hooks/useFormState'
import { useVestigioService } from 'hooks/useVestigioService'
import { useSetorService } from 'hooks/useSetorService'
import { useUsuarioService } from 'hooks/useUsuarioService'

const schema = {
  lacre: {
    presence: { allowEmpty: false, message: '^Lacre é obrigatório' },
  },
  setorDestino: {
    presence: { allowEmpty: false, message: '^Setor destino é obrigatório' },
  },
  usuarioRecebedor: {
    presence: { allowEmpty: false, message: '^Usuário recebedor é obrigatório' },
  },
}

export const useEntregarVestigio = () => {
  const router = useRouter()
  const params = useParams()
  const vestigioService = useVestigioService()
  const setorService = useSetorService()
  const usuarioService = useUsuarioService()

  const [vestigio, setVestigio] = useState(null)
  const [processandoVestigio, setProcessandoVestigio] = useState(false)
  const [setores, setSetores] = useState([])
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [isFormError, setIsFormError] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)

  const entregaVestigioForm = useFormState(schema, {
    lacre: null,
    tipoEmbalagem: null,
    outroTipoEmbalagem: null,
    setorDestino: null,
    usuarioRecebedor: null,
    usuarioRecebedorInput: null,
    arquivos: [],
  })

  const fetchSetores = useCallback(async () => {
    const result = await setorService.listarSetoresAsync(setProcessandoSetores)
    setSetores(result)
  }, [])

  const fetchUsuarios = useCallback(async () => {
    const result = await usuarioService.listarUsuariosAsync(setProcessandoUsuarios)
    setUsuarios(result)
  }, [])

  const fetchVestigio = useCallback(async () => {
    const response = await vestigioService.listarVestigioAsync(params.id, setProcessandoVestigio)
    setVestigio(response)
  }, [params.id])

  const handleClickConfirmar = () => {
    setAbrirEspelho(true)
  }

  const handleConfirmarOperacao = async () => {
    await vestigioService.entregarVestigio(params.id, entregaVestigioForm.formState.values, setProcessandoOperacao)
    router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
  }
  
  const setArquivosUpload = useCallback((ids) => {
    entregaVestigioForm.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        arquivos: ids,
      },
    }))
  }, [])

  useEffect(() => {
    fetchUsuarios()
  }, [fetchUsuarios])

  useEffect(() => {
    fetchSetores()
  }, [fetchSetores])

  useEffect(() => {
    fetchVestigio()
  }, [fetchVestigio])

  useEffect(() => {
    if (vestigio?.id) {
      entregaVestigioForm.setFormState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          lacre: vestigio.lacre,
          tipoEmbalagem: vestigio.tipoEmbalagem,
          outroTipoEmbalagem: vestigio.outroTipoEmbalagem,
          usuarioRecebedorInput: vestigio.usuarioRecebedorInput,
        },
      }))
    }
  }, [vestigio])

  useEffect(() => {
    if (
      entregaVestigioForm.formState.errors.lacre ||
      entregaVestigioForm.formState.errors.setorDestino ||
      entregaVestigioForm.formState.errors.usuarioRecebedor
    ) {
      setIsFormError(true)
    } else {
      setIsFormError(false)
    }
  }, [entregaVestigioForm])

  return {
    entregaVestigioForm,
    vestigio,
    processandoVestigio,
    setores,
    processandoSetores,
    usuarios,
    processandoUsuarios,
    abrirEspelho,
    setAbrirEspelho,
    isFormError,
    processandoOperacao,
    setArquivosUpload,
    handleClickConfirmar,
    handleConfirmarOperacao,
    router,
    params,
  }
}
